import scribdAuthorize from '../scribd/scribd_oauth.js';

(function(slideshare_object, $) {
  $(document).ready(function() {
    $('.userStats a.j-follow').click(function(e) {
      e.preventDefault();
      e.stopPropagation();

      var eventConfig = {
        "event": "follow",
        "data": { "contactee" : $(this).data('contactee') }
      };

      slideshare_object.addAfterLoginEvent(eventConfig);
      scribdAuthorize({ from_source: window.location.pathname + window.location.search });
    });
  });
})(window.slideshare_object, $);